import axios from "axios"
export function reopenBusinessDetails(userId, token) {
    return axios.get(process.env.REACT_APP_API_URL + `/reopenBusinessDetails?userId=${userId}`, {
        headers: {
            'Authorization': `${token}`
        }
    });
}